module.exports = __webpack_public_path__ + "static/media/fvs_valve1_62.f71a5e6e.jpg";